import React, { createContext, useState, useMemo, useContext } from "react";
import Api from '../__helpers/api';

export const AuthDataContext = createContext({});

const initialAuthData = {
    isLogged: false,
    user: {}
};

const AuthDataProvider = props => {
    const [authData, setAuthData] = useState(initialAuthData);

    const getAuthData = () => {
        let currentAuthData = localStorage.getItem('auth') ? JSON.parse(localStorage.getItem('auth')) : initialAuthData;

        setAuthData(currentAuthData);

        if (currentAuthData.isLogged) {
            refresh();
        }

    }

    const refresh = () => {
        Api.get('profile')
            .then(response => {
                let currentAuthData = response.data;
                login(currentAuthData);
            }).catch(err => {
                localStorage.removeItem('auth');
                setAuthData(initialAuthData);
            });
    }

    const login = newAuthData => {

        if (!newAuthData.is_student && newAuthData.confirmed == 0) {
            localStorage.setItem('auth-activated', JSON.stringify(0));
            return;
        }
        let state = {
            isLogged: true,
            user: newAuthData
        }
        localStorage.setItem('auth', JSON.stringify(state));
        setAuthData(state);
    }

    const logout = () => {
        localStorage.clear();
        // setAuthData(initialAuthData);
        window.location = '/';
    }

    useMemo(() => {
        getAuthData();
    }, []);

    const auth = useMemo(() => ({ ...authData, login, refresh, logout }), [authData]);

    return <AuthDataContext.Provider value={auth} {...props} />;
};

export const useAuthDataContext = () => useContext(AuthDataContext);

export default AuthDataProvider;